// extracted by mini-css-extract-plugin
module.exports = {"root":"container-module--root--1Rzp1"};